<template>
  <div>
    <v-btn text @click="dialog = true">Categorize</v-btn>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card dark>
        <v-card-title>
          <span class="headline">Categorize Email</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-select :items="categories" label="Category" v-model="selectedCategory"></v-select>
              </v-col>
              <v-col cols="12">
                <v-select :items="studios" item-text="name" item-value="_id" label="Studio" v-model="selectedStudio"></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex"

export default {
  name: "CategoryManager",
  data: () => ({
    dialog: false,
    selectedCategory: null,
    selectedStudio: null,
  }),
  computed: {
    ...mapGetters("mailStore", ["categories"]),
    ...mapGetters("studioStore", { studios: "getStudios" }),
    ...mapState("mailStore", ["selectedEmail"]),
  },
  watch: {
    selectedEmail: {
      handler(email) {
        if (email) {
          this.selectedCategory = email.category
          this.selectedStudio = email.studio ? email.studio._id : null
        }
      },
      immediate: true,
    },
  },
  methods: {
    save() {
      this.$store.dispatch("mailStore/categorizeEmail", {
        emailId: this.selectedEmail._id,
        category: this.selectedCategory,
        studioId: this.selectedStudio,
      })
      this.dialog = false
    },
  },
}
</script>
